export default function getFormData($form: HTMLFormElement) {
  const obj = [];
  const data = new FormData($form);
  for (const entry of data) {
    obj.push(entry);
  }
  return obj;
}
